module.exports = __webpack_public_path__ + "static/media/NoirPro-Regular.752c13e1.eot";